// Module
var code = "<span class=\"needletail-clear-filters {{ hidden }}\">{{{ text }}}</span>";
// Exports
export default code;